import { Box, Button, TextField } from "@material-ui/core"
import { createRef } from "react"
import type { ChangeEvent, ReactElement } from "react"
import { useTranslation } from "react-i18next"

export interface IUploadFileFieldProps {
  file: File | null
  accept?: string
  buttonOnly?: boolean
  onSelect: (file: File) => void
}

export function UploadFileField(props: IUploadFileFieldProps): ReactElement {
  const { file, accept, buttonOnly, onSelect } = props
  const { t } = useTranslation("map")
  const fileInputRef = createRef<HTMLInputElement>()

  function handleFileSelect(event: ChangeEvent<HTMLInputElement>): void {
    const files: FileList | null = event.currentTarget.files
    if (files !== null && files.length === 1) {
      const file = files[0]
      onSelect(file)
    }
  }

  function handleSelectButtonClick(): void {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <Box className="file-input-field">
      <input ref={fileInputRef} type="file" accept={accept} onChange={handleFileSelect} style={{ display: "none" }} />
      {!buttonOnly && (
        <TextField
          value={file === null ? "" : file.name}
          fullWidth
          variant="outlined"
          InputProps={{
            endAdornment: (
              <Button onClick={handleSelectButtonClick} variant="contained" color="primary" className="upload-button">
                {t("attachments.browse")}
              </Button>
            )
          }}
        />
      )}
      {buttonOnly && (
        <Button onClick={handleSelectButtonClick} variant="outlined" className="upload-button" color="primary">
          {t("attachments.chooseFile")}
        </Button>
      )}
    </Box>
  )
}
